export class City {
  id: number;
  name: string;
  geo_context: string;
  default: boolean;
  time_zone: number;
}
